import { FC } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { cn, FaIcon } from '@fe-learner-common';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';

type ChipProps = {
  className?: string;
  icon?: IconDefinition;
  label: string;
  onRemove?: () => void;
};

export const Chip: FC<ChipProps> = ({
  className,
  icon,
  label,
  onRemove,
  ...rest
}) => {
  return (
    <button
      className={cn(
        'lf:text-neutral-900 lf:flex lf:items-center lf:gap-1.5 lf:rounded-full lf:bg-neutral-100 lf:px-3 lf:py-2 lf:text-label-md lf:hover:bg-neutral-200',
        className,
      )}
      onClick={onRemove}
      {...rest}
    >
      {icon && <FaIcon icon={icon} width={16} height={16} />}
      <span>{label}</span>
      {onRemove && <FaIcon icon={faXmark} width={16} height={16} />}
    </button>
  );
};
